"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BPLoggeFlowType = void 0;
var BPLoggeFlowType;
(function (BPLoggeFlowType) {
    BPLoggeFlowType["OrderToCash"] = "order_to_cash";
    BPLoggeFlowType["ReturnToRefund"] = "return_to_refund";
    BPLoggeFlowType["ProcureToPay"] = "procure_to_pay";
    BPLoggeFlowType["DemandToSupply"] = "demand_to_supply";
    BPLoggeFlowType["ProspectToCustomer"] = "prospect_to_customer";
    BPLoggeFlowType["IdeaToMarket"] = "idea_to_market";
})(BPLoggeFlowType = exports.BPLoggeFlowType || (exports.BPLoggeFlowType = {}));
//# sourceMappingURL=bp-logger-flow-type.js.map